import { render, staticRenderFns } from "./Whxq.vue?vue&type=template&id=9c87eb6e&scoped=true&"
import script from "./Whxq.vue?vue&type=script&lang=js&"
export * from "./Whxq.vue?vue&type=script&lang=js&"
import style0 from "./Whxq.vue?vue&type=style&index=0&id=9c87eb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c87eb6e",
  null
  
)

export default component.exports